import { GET_METABASE_DASHBOARD_IFRAME_URL } from './getMetabaseDashboardIframeURL';

export const metabaseApi = {
  metabaseDashboardIframeURL: GET_METABASE_DASHBOARD_IFRAME_URL,
};
